import React from "react";

import { goTo, profileFileUpload, useAppType, useNavigate, useUserContext } from "utils";

import { Avatar, AvatarImage, Col, Icon, Row, Typography, UploadImage } from "components";

export const ProfileBanner = ({ details, imageSuccess, setImageSuccess, imageURL, setImageURL, t }) => {
  const { user } = useUserContext();
  const appType = useAppType();
  const avatarSize = appType.desktop ? "xl" : "l";
  const navigate = useNavigate();

  return (
    <Row align="middle">
      <Col className="center avatar">
        {!details.image && !imageURL ? (
          <Avatar size={avatarSize} name={`${user.firstName} ${user.lastName}`} />
        ) : (
          <AvatarImage size={avatarSize} image={imageURL} />
        )}
        <Icon iconName="tabler/edit" className="icon inline" size="m" onClick={(e) => goTo(e, navigate, "/user/update")} />
        <UploadImage
          beforeUpload={(file) => profileFileUpload(file, setImageSuccess, setImageURL, t, true)}
          id="profile-image-upload"
          imageSuccess={imageSuccess}
          imageUrl={imageURL}
          profile
        />
      </Col>
      <Col>
        <div className="background grey-bg center" />
        <Row gutter={[{ sm: 8, md: 16 }, 0]} justify="space-around" align="middle">
          <Col className="center">
            <Typography variant="h2" className="user-name">
              {user.firstName} {user.lastName}
            </Typography>
          </Col>
        </Row>
        <Row gutter={[{ sm: 8, md: 16 }, 0]}>
          <Col className="center">
            <Typography variant="paragraph-m" className="margin-0">
              {details.region && (
                <Typography variant="paragraph-m" className="region">
                  <Icon iconName="klim/map-pin" size="s" className="icon" /> {details.region}
                </Typography>
              )}
            </Typography>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
